<template>
  <div class="dashboard-sessions-list">
    <v-row>
      <v-text-field v-model='search' :readonly='!startSearching' @focus='startSearching = true' label='Search' @keydown.enter='searchSessions' outlined class='searchbox'></v-text-field>
      <v-btn @click='searchSessions' large text rounded outlined class='searchbtn'>Submit</v-btn>
    </v-row>
    <sample-list-session-item :name="'Try Me Out!'" :type="'3x3'"/>
    <v-list v-for='(session, index) in sessions' :key='index'>
      <list-session-item v-if='!session.error' :name='session.sessionName' :creator='session.creator' :type='session.sessionType' :id='session.sessionId' :spectatorMode='session.spectatorMode' source='dashboard_page' />
      <v-alert v-else :type='session.type'>
        {{session.message}}
      </v-alert>
    </v-list>
    If you don't find the session you're looking for, then ask your friend for the session id (the long number at the end of the URL) or check your browser history.<br/>
    If you forgot your session pasword then you need to ask the creator to enter the session and reset it from there<br/>
    <!-- TODO: fix above problems. ie, add a sessions search endpoint with pagination and a forgot password endpoint with auth -->
  </div>
</template>

<script>
import ListSessionItem from '@/components/ListSessionItem'
import SampleListSessionItem from '@/components/SampleListSessionItem'
import SessionsService from '@/services/SessionsService'
export default {
  name: 'dashboard-sessions-list',
  data () {
    return {
      search: '',
      startSearching: false,
      sessions: []
    }
  },
  methods: {
    async searchSessions() {
      let response = await SessionsService.searchSessions({
        name: this.search,
      })
      if (response.data.error) {
        this.sessions = [{
          type: 'error',
          error: response.data.error,
          message: response.data.message,
        }]
        return
      }
      if (response.data.sessions.length === 0) {
        this.sessions = [{
          type: 'warning',
          error: 'noSessionsFound',
          message: `No sessions were found for the search ${this.search}`,
        }]
        return
      }
      this.sessions = response.data.sessions
    }
  },
  async created () {
    var response = await SessionsService.listSessions()
    this.sessions = response.data.sessions
  },
  components: {
    ListSessionItem,
    SampleListSessionItem
  }
}
</script>

<style scoped>
.searchbox {
  padding: 0 20px !important;
}
.searchbtn {
  margin-right: 40px !important;
}
</style>
